import { getCustomViewCountsRpc } from 'find-and-filter-data/__generated__/chirp/com/hubspot/cv/custom/views/realtime/rpc/CvCustomViewsRealtimeRpc';
import { chirpClient } from 'find-and-filter-data/chirp/chirp-client';

/**
 * @description Fetches updated counts for the given view IDs.
 */
export function fetchUpdatedViewsService(request) {
  return chirpClient.call(getCustomViewCountsRpc, {
    request
  });
}